













































import * as Vue from '@vue/composition-api'
import StageItem from './StageItem.vue'
import MainChara from './MainChara.vue'
import StageController from './StageController.vue'
import RRect from '@/ts/if/RRect'
import acceItems from '@/ts/model/acceItems'
import charaOptions from '@/ts/model/charaOptions'
import StageDescription from '@/ts/model/StageDescription'
import StageItemDescription from '../ts/model/StageItemDescription'
import { Pos, Size } from '@/ts/if/graphics'
import { imageFromDom } from '@/ts/logics/imageTools'

interface ItemData {
  id: number,
  acceName: string,
  order: number,
  pos?: { x: number, y: number},
  scale?: number
  angle?: number
}

export default Vue.createComponent({
  name: 'Stage',
  components: { StageItem, MainChara, StageController },
  setup (props, ctx) {
    const stageElem = Vue.ref()
    const itemComps = Vue.ref()
    const mainCharaComp = Vue.ref()
    const mainItem: ItemData = {
      id: 1,
      acceName: 'CHARA',
      order: 100
    }
    const data = Vue.reactive({
      mainItem,
      items: [mainItem],
      selId: 0,
      charaHairName: '',
      charaDressName: '',
      stageSize: { w: 750, h: 800 }
    })
    const readOnly = Vue.computed(() => {
      return ctx.root.$store.state.doc.docOrdered
    })
    const orderedItems = Vue.computed<ItemData[]>(() => {
      return data.items.sort((a, b) => a.order - b.order)
    })
    const minOrder = Vue.computed(() => {
      const item = orderedItems.value[0]
      if (item) {
        return item.order
      } else {
        return 0
      }
    })
    const maxOrder = Vue.computed(() => {
      const item = orderedItems.value[orderedItems.value.length - 1]
      if (item) {
        return item.order
      } else {
        return 0
      }
    })

    const currentOptions = Vue.computed(() => {
      return {
        hair: charaOptions[data.charaHairName || 'Hair1'],
        dress: charaOptions[data.charaDressName || 'Dress1']
      }
    })

    const addItem = (name: string) => {
      const acceDef = acceItems[name]
      if (!acceDef) { return }

      data.items.push({
        id: Math.max(...data.items.map(item => item.id)) + 1,
        acceName: name,
        order: maxOrder.value + 1
      })
    }
    const deleteItem = (id: number) => {
      data.items = data.items.filter(item => item.id !== id)
    }
    const changeHair = (name: string) => {
      data.charaHairName = name
    }
    const changeDress = (name: string) => {
      data.charaDressName = name
    }

    const onSelect = (selItem: ItemData) => {
      const comps = itemComps.value as any
      data.selId = selItem.id
      comps.forEach((item: any) => {
        if (item.id !== selItem.id) {
          item.deselect()
        }
      })
    }
    const onDeselect = async (selItem: ItemData) => {
      if (selItem.id === data.selId) {
        await 0
        const comps = itemComps.value as any
        comps.forEach((item: any) => {
          if (item.id === selItem.id) {
            // item.select()
          }
        })
      }
    }

    const onItemChange = (item: ItemData, pos: Pos, scale: number, angle: number) => {
      item.pos = pos
      item.scale = scale
      item.angle = angle
    }

    const itemDataById = (id: number) => {
      return data.items.filter(item => item.id === id)[0]
    }

    const compById = (id: number) => {
      const comps = itemComps.value as any
      return comps.filter((comp: any) => comp.id === id)[0]
    }

    const goForward = () => {
      if (isNaN(data.selId)) { return }
      const orderedIndex = orderedItems.value.findIndex(item => item.id === data.selId)
      const item = orderedItems.value[orderedIndex]
      const target = orderedItems.value[orderedIndex + 1]
      if (!item || !target) { return }
      const targetOrder = target.order
      target.order = item.order
      item.order = targetOrder
    }
    const goBackward = () => {
      if (isNaN(data.selId)) { return }
      const orderedIndex = orderedItems.value.findIndex(item => item.id === data.selId)
      const item = orderedItems.value[orderedIndex]
      const target = orderedItems.value[orderedIndex - 1]
      if (!item || !target) { return }
      const targetOrder = target.order
      target.order = item.order
      item.order = targetOrder
    }

    /**
     * Get items layout information including all StageItems.
     * This data includs all information to restore current stage layout.
     */
    const stageDescription = Vue.computed(() => {
      const chara = mainCharaComp.value as any
      if (!chara) { return undefined }
      const sd = new StageDescription(chara.description)
      sd.items = data.items.map(item => {
        const comp = compById(item.id)
        if (comp) {
          const desc = comp.description
          desc.order = item.order
          return desc
        }
      }).filter(desc => desc)
      return sd
    })

    const restoreDescriptopn = (desc: StageDescription) => {
      data.charaHairName = desc.chara.hair || ''
      data.charaDressName = desc.chara.dress || ''
      data.items = []
      if (desc.items) {
        data.items = desc.items.map(item => {
          return {
            id: item.id,
            acceName: item.acceName,
            order: item.order,
            pos: { x: item.x, y: item.y },
            scale: item.scale,
            angle: item.angle
          }
        })
      }
      const mainItemData = data.items.find(item => item.acceName === 'CHARA')
      if (mainItemData) {
        data.mainItem = mainItemData
      } else {
        throw new Error('Invalid description. No main chara item found in description items array.')
      }
    }

    const toImage = async (scale: number = 1.0, format: 'jpeg' | 'png' = 'jpeg', quality: number = 0.45) => {
      const stage = stageElem.value
      const comps = itemComps.value as any
      comps.forEach((item: any) => {
        item.deselect()
      })
      if (stage) {
        const el = (stage as any).$el
        return imageFromDom(stage, scale, format, quality)
      }
    }

    return {
      stageElem,
      itemComps,
      mainCharaComp,
      data,
      readOnly,
      orderedItems,
      minOrder,
      maxOrder,
      currentOptions,
      addItem,
      deleteItem,
      changeHair,
      changeDress,
      onItemChange,
      onSelect,
      onDeselect,
      goForward,
      goBackward,
      stageDescription,
      restoreDescriptopn,
      toImage
    }
  }
})
